export default __webpack_public_path__ + "static/media/20t.b50d9eae.jpg";